import { useEffect, useState } from 'react';
import { useNavigate } from 'react-router-dom';
import { apiGet } from '../lib/api-client';
import { useAuth } from '../contexts/AuthContext';
import { Button } from '../components/ui/Button';
import { useNotice } from '../components/ui/Notice';
import { Input } from '../components/ui/Input';

export function LoginPage() {
  const { login } = useAuth();
  const notice = useNotice();
  const navigate = useNavigate();
  const [email, setEmail] = useState('ivan.milic@maxiron.com');
  const [mock, setMock] = useState(false);
  const [error, setError] = useState('');

  useEffect(() => {
    void apiGet<{ mock: boolean }>('/api/auth/mode').then((mode) => setMock(mode.mock)).catch(() => setMock(false));
  }, []);

  async function go() {
    setError('');
    try {
      await login(email);
      navigate('/');
    } catch {
      notice.failure('Sign in failed');
    }
  }

  return (
    <div className="flex min-h-screen flex-col items-center justify-center bg-gray-50 p-6 dark:bg-gray-950">
      <div className="mb-8 inline-flex items-center gap-3" aria-label="MaxIron Backoffice">
        <img src="/maxiron-mark.svg" alt="" className="h-12 w-12" />
        <span className="leading-none">
          <span className="block text-[1.65rem] font-bold tracking-[0.18em]">MAXIRON</span>
          <span className="mt-1 block text-[0.7rem] font-bold tracking-[0.28em] text-[#8F00FF]">BACKOFFICE</span>
        </span>
      </div>
      <div className="w-full max-w-md rounded-xl border border-gray-200 bg-white p-8 shadow-sm dark:border-gray-700 dark:bg-gray-900">
        <h2 className="mb-2 text-2xl font-semibold">Sign in</h2>
        <p className="mb-6 text-sm text-gray-500">Microsoft Entra SSO for your MaxIron account.</p>
        <a className="inline-flex h-10 w-full items-center justify-center rounded-md bg-blue-600 font-medium text-white" href="/api/azure-auth/login">Sign in with Microsoft</a>
        {mock ? (
          <div className="mt-6">
            <p className="mb-3 text-sm text-gray-500">Local mock SSO is on.</p>
            <Input className="mb-3" value={email} onChange={(event) => setEmail(event.target.value)} />
            <Button variant="ghost" className="w-full" onClick={() => void go()}>Continue</Button>
          </div>
        ) : null}
        {error ? <p className="mt-3 text-sm text-red-600">{error}</p> : null}
      </div>
    </div>
  );
}
